"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HttpClientError = void 0;

function _extendableBuiltin(cls) {
  function ExtendableBuiltin() {
    var instance = Reflect.construct(cls, Array.from(arguments));
    Object.setPrototypeOf(instance, Object.getPrototypeOf(this));
    return instance;
  }

  ExtendableBuiltin.prototype = Object.create(cls.prototype, {
    constructor: {
      value: cls,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });

  if (Object.setPrototypeOf) {
    Object.setPrototypeOf(ExtendableBuiltin, cls);
  } else {
    ExtendableBuiltin.__proto__ = cls;
  }

  return ExtendableBuiltin;
}

class HttpClientError extends _extendableBuiltin(Error) {
  constructor(message, status, data, headers) {
    super(message);
    this.name = 'HttpClientError';
    this.status = status;
    this.data = data;
    this.headers = headers;
    Object.setPrototypeOf(this, HttpClientError.prototype);
  }

}

exports.HttpClientError = HttpClientError;